import { CategoryCounts } from '../types';

export interface HighestCategoryResult {
  category: string;
  count: number;
}

/**
 * Calculate the highest category from category counts
 * If there's a tie, returns category 'E' as default
 */
export const calculateHighestCategory = (categoryCounts: CategoryCounts): HighestCategoryResult => {
  // Find all categories with the highest count
  const entries = Object.entries(categoryCounts);
  const maxCount = Math.max(...Object.values(categoryCounts));
  const highestCategories = entries.filter(([_, count]) => count === maxCount);

  // Check if there's a tie (more than one category with the highest count)
  const hasTie = highestCategories.length > 1;

  // If there's a tie, use the default category, otherwise use the highest category
  return hasTie
    ? { category: 'E', count: maxCount }
    : { category: highestCategories[0][0], count: maxCount };
};
